const GlobalScope = {
    install: (Vue) => {
        Vue.prototype.$scope = { ...window.initialScope };
    },
};

export default GlobalScope;
